import { useCategorias } from '@/api/categorias';
import { cn } from '@/lib/utils';

/** Valor da API para "sem categoria" (filtros: `categoriaId=SEM`). Nao e id de categoria (id e cuid). */
export const SEM_CATEGORIA = 'SEM';

const TODAS = '__todas__';
const ROTULO = 'mb-1.5 block text-caption font-medium text-ink-secondary';
const CAMPO = 'h-10 w-full min-w-[160px] rounded-[10px] border border-input bg-card px-2.5 text-small text-ink-body focus-visible:border-primary focus-visible:shadow-focus focus-visible:outline-none disabled:opacity-50';

export interface SeletorCategoriaProps {
  id: string;
  /** Texto do `<label>` (nome acessivel do select). */
  rotulo: string;
  /** Some visualmente (o rotulo continua para leitores de tela). */
  ocultarRotulo?: boolean;
  /**
   * Id da categoria, `SEM` (sem categoria) ou vazio. Com `comTodas`, vazio = todas as categorias (filtro).
   * Sem `comTodas`, vazio = sem categoria (campo de item: o pai converte `SEM` em null/undefined ao gravar).
   */
  value: string | null | undefined;
  /** Recebe o id, `SEM`, ou `undefined` quando escolhe "Todas as categorias" (so com `comTodas`). */
  onChange: (valor: string | undefined) => void;
  /** Opcao "Todas as categorias" (filtros). Padrao: nao. */
  comTodas?: boolean;
  /** Opcao "Sem categoria". Padrao: sim. */
  comSem?: boolean;
  disabled?: boolean;
  className?: string;
}

/**
 * Select de categoria (arvore de GET /categorias). Opcoes na ordem da arvore, indentadas pelo nivel e com o caminho ("Embalagens > Caixas").
 * Presentacional: so escolhe; o filtro e aplicado pela API no pai.
 */
export function SeletorCategoria({ id, rotulo, ocultarRotulo = false, value, onChange, comTodas = false, comSem = true, disabled, className }: SeletorCategoriaProps) {
  const categorias = useCategorias();
  const lista = categorias.data?.categorias ?? [];
  const atual = value || undefined;
  const exibido = atual ?? (comTodas ? TODAS : SEM_CATEGORIA);
  // Categoria gravada que ainda nao chegou na lista (carregando, ou fora da empresa): aparece para o select nao ficar vazio.
  const desconhecida = atual !== undefined && atual !== SEM_CATEGORIA && !lista.some((c) => c.id === atual);

  return (
    <>
      <label htmlFor={id} className={ocultarRotulo ? 'sr-only' : ROTULO}>
        {rotulo}
      </label>
      <select
        id={id}
        value={exibido}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value === TODAS ? undefined : e.target.value)}
        className={cn(CAMPO, className)}
      >
        {comTodas && <option value={TODAS}>Todas as categorias</option>}
        {comSem && <option value={SEM_CATEGORIA}>Sem categoria</option>}
        {desconhecida && <option value={atual}>Categoria atual</option>}
        {lista.map((c) => (
          <option key={c.id} value={c.id}>
            {'  '.repeat(c.nivel)}
            {c.caminho}
          </option>
        ))}
      </select>
    </>
  );
}
